'use client'
import { createContext, ReactNode, useContext } from 'react'

import { ClubConfig, COPY_KEY } from '~/utils/clubConfig/types'
import { MARKETS } from '~/utils/consts'

const defaultContext: ClubConfig = {
  defaultPhoneNumberCountry: MARKETS.pl,
  copyKey: COPY_KEY.Pl,
  supportEmail: '',
  allowRedirectToFestivalsListing: true,
}

const MarketContext = createContext<ClubConfig>(defaultContext)

export function useMarketContext() {
  const context = useContext(MarketContext)

  if (!context) {
    throw new Error('useMarketContext must be used within a MarketClientSideContextProvider in a client-side component')
  }

  return context
}

export const MarketClientSideContextProvider = ({
  value,
  children,
}: Readonly<{
  value: ClubConfig
  children: ReactNode
}>) => {
  return <MarketContext.Provider value={value}>{children}</MarketContext.Provider>
}
